import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {linkFinder} from '../../core/links'
import Card from '../../core/components/Card'
import {DEFAULT_TICKET_CLAIM_QUERY, queryTicketClaimStream} from '../actions'
import i18n from '../i18n'
import style from './TicketClaimCountCard.less'

class TicketClaimCountCard extends Component {
    static propTypes = {
        ticket: PropTypes.object.isRequired
    }

    componentWillMount() {
        const {dispatch} = this.props
        dispatch(queryTicketClaimStream({...DEFAULT_TICKET_CLAIM_QUERY, range: {offset: 0, limit: 0}}))
    }

    render() {
        const {dispatch, range, _appLinks, ...others} = this.props

        const header = (
            <h3>{i18n.ticketClaim}</h3>
        )

        return !!_appLinks.find(linkFinder('ticketclaims')) && (
            <div className={style.default}>
                <Card
                    status='danger'
                    header={header}
                    onClick={() => dispatch(push('/claims'))}>
                    <p>{range && range.count} {i18n.ticketClaims}</p>
                </Card>
            </div>
        )
    }
}

TicketClaimCountCard = connect((state) => ({
    range: state.claim.range,
    _appLinks: state.app._links
}))(TicketClaimCountCard)

export default TicketClaimCountCard


// WEBPACK FOOTER //
// ./lib/claim/components/TicketClaimCountCard.js